const f = ["#ffffd1", "#89c6bd", "#4265af", "#040c44"], E = ["#ffffd1", "#add8b7", "#447db3", "#3f4cab", "#040c44"], c = [
  "#ffffd1",
  "#add8b7",
  "#64b4c2",
  "#447db3",
  "#3f4cab",
  "#040c44"
];
export {
  f as DEMOGRAPHICS_GREEN_BLUE_4,
  E as DEMOGRAPHICS_GREEN_BLUE_5,
  c as DEMOGRAPHICS_GREEN_BLUE_6
};
//# sourceMappingURL=index.es5600.js.map
